<template>
  <b-section-loader :loading="$loading.isLoading(['init', 'getPlan'])">
    <div class="d-flex flex-column ga-5">
      <plan-item
        :plan="plan"
        style="margin-bottom: 0 !important"
        @update="Object.assign(plan, $event)">
        <template #append>
          <files-uploader
            v-model="plan.approvedPlan"
            :name-folder="String(plan.id)"
            file-list
            label="Погоджений план"
            main-folder="План"
            @update:model-value="updateDocument"></files-uploader>
        </template>
      </plan-item>

      <div class="d-flex align-center justify-space-between">
        <h4 class="font-weight-bold font-size-16">Аудити у складі плана</h4>

        <div class="d-flex ga-3">
          <v-menu>
            <template #activator="{ props }">
              <v-btn v-bind="props">
                <v-icon class="mr-1" icon="mdi-plus"></v-icon>
                <span>Додати аудит</span>
              </v-btn>
            </template>
            <v-list>
              <v-list-item prepend-icon="mdi-plus" @click="auditCreate">
                <span>Створити новий</span>
              </v-list-item>
              <v-list-item prepend-icon="mdi-plus" @click="auditAttach">
                <span>Додати існуючий</span>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>

      <v-data-table
        :headers="planAuditListHeaders"
        :items="planAuditList"
        :items-per-page="-1"
        hide-default-footer>
        <template #item.name="{ item }">
          <router-link
            :to="{ name: 'audit-single', params: { id: item.id } }"
            class="link">
            {{ item.name }}
          </router-link>
        </template>
        <template #item.author="{ item }">
          <span>{{ getPersonName(item.author, { initials: true }) }}</span>
        </template>
        <template #item.date="{ item }">
          <div
            v-if="!item.startAuditDate && !item.endAuditDate"
            class="text-disabled">
            Дата не вказана
          </div>
          <div v-else>
            {{ new CustomDate(item.startAuditDate).toString() }} -
            {{ new CustomDate(item.endAuditDate).toString() }}
          </div>
        </template>
        <template #item.status="{ item }">
          <v-chip
            :style="getColorByStatus(item.statusId)"
            border
            class="font-weight-bold"
            density="comfortable"
            rounded="lg"
            size="small"
            variant="flat"
            style="width: max-content">
            <template #default>
              {{ item?.status?.name }}
            </template>
          </v-chip>
        </template>
        <template #item.delete="{ item }">
          <v-btn
            border
            class="text-none"
            color="error"
            variant="outlined"
            @click="auditDetach(item.id)">
            <span class="font-weight-medium text-error">
              Виключити з плану
            </span>
          </v-btn>
        </template>
      </v-data-table>
    </div>
  </b-section-loader>
</template>

<script lang="ts">
import { BSectionLoader } from 'best-modules/components'
import PlanItem from '@/pages/audit/plans/PlanItem.vue'
import { planAuditListHeaders } from '@/utils/tableHeaders'
import { initPlan } from './plan'
import { CustomDate } from 'best-modules/utils'
import { getColorByStatus } from '@/pages/audit/helpers'
import FilesUploader from '@/components/filesUploader/FilesUploader.vue'
import { getPersonName } from 'best-modules/utils/helpers'

export default {
  name: 'PlanSingle',
  components: { FilesUploader, PlanItem, BSectionLoader },
  data() {
    return { planAuditListHeaders }
  },
  methods: { getPersonName, getColorByStatus, CustomDate },
  setup() {
    return { ...initPlan() }
  },
}
</script>

<style lang="scss" scoped></style>
